<template>
  <div class="priority-item queue-processing">
    <div class="d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center gap-10">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="21" viewBox="0 0 18 21" fill="none">
          <path d="M18 7.85881H12.8571V0.799988H5.14286V7.85881H0L9 16.0941L18 7.85881ZM0 18.447V20.8H18V18.447H0Z" fill="#2D5089"/>
        </svg>
        <strong class="font-size-125">{{ 'Download Started' | trans }}</strong>
      </div>
      <div class="all-files-box">
        <small class="font-weight-bold" v-if="currentJob.downloadedOutputs.length > 1 && currentJob.downloadedOutputs.length === currentJob.apiJob.output.length">
          {{'All files' | trans}}
        </small>
        <small class="font-weight-bold" v-if="currentJob.downloadedOutputs.length > 1 && currentJob.downloadedOutputs.length < currentJob.apiJob.output.length">
          {{ currentJob.downloadedOutputs.length }} {{'Files'|trans}}
        </small>
        <small class="font-weight-bold short-text-name" v-if="currentJob.downloadedOutputs.length === 1">
          {{ this.getSingleSelectedFilename() |decodeUrl }}
        </small>
      </div>
    </div>
    <div> 
      <p>{{ 'Your download should start automatically.' | trans }}</p>
      <a id="clickHereToDownloadLink" v-html="downloadText" @click="this.downloadJob" :href="downloadLink"></a>
    </div>
    <p v-if="isFreeUser">
      {{ 'Get a subscription to bypass the queue, enjoy PRO features and process your files faster.' | trans }}
    </p>
    <button v-if="isFreeUser" class="btn queue-btn bg-warning w-50" @click="openPremiumModal">
      <i class="fa fa-chevron-right"></i><strong>{{ 'Get Premium' | trans }}</strong>
    </button>
  </div>
</template>
<script>
import store from './../../../mixins/store.mixin'
import currentJob from './../../../mixins/current_job.mixin'
import user from "../../../mixins/user.mixin";
import DownloadManager from "../../../manager/DownloadManager";
import PreviewManager from "../../../manager/PreviewManager";
import OutputSelectionManager from '../../../manager/OutputSelectionManager';
import Analytics from "../../../util/Analytics";
import {
  registerPaymentModalHelper
} from "../../../../../../../../lib-sat/user/modal/register_payment_flow/register-payment-modal-helper";

export default {
  name: "QueueDownload",
  props: {},
  components: {},
  mixins: [
    store,
    currentJob,
    user,
  ],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {
    openPremiumModal() {
      registerPaymentModalHelper.openUpgrade().then(() => {
        this.modalToShow = null;
      });
    },
    async downloadJob() {
      if (OutputSelectionManager.getSelectedOutputs(this.currentJob).length === 0) {
        return;
      }

      if (this.currentJob.apiJob.output.length === 1) {
        Analytics.send('result_download', 'primary_single', this.currentJob);

        await DownloadManager.downloadOutput(this.currentJob.apiJob.output[0], this.currentJob);
        return;
      }

      if (OutputSelectionManager.getSelectedOutputs(this.currentJob).length === 1) {
        Analytics.send('result_download', 'primary_single', this.currentJob);
        await DownloadManager.downloadOutput(OutputSelectionManager.getSelectedOutputs(this.currentJob)[0], this.currentJob)
        return;
      }

      if (OutputSelectionManager.getSelectedOutputs(this.currentJob).length > 1 
          && OutputSelectionManager.getSelectedOutputs(this.currentJob).length < OutputSelectionManager.getAllOutputs(this.currentJob).length ) {
          Analytics.send('result_download', 'secondary_zip', this.currentJob);
          await DownloadManager.downloadSelectedOutputsAsZip(this.currentJob.id);
        return;
      }

      Analytics.send('result_download', 'primary_zip', this.currentJob);

      await DownloadManager.downloadJobAsZip(this.currentJob.id);
    },
    getSingleSelectedFilename() {
      let output = this.getOutputById(this.currentJob.id, this.selectedOutputs[0]);
      return PreviewManager.getFilenameFromOutput(output);
    },
  },
  computed: {
    downloadText() {
      return this.translate(`If not, <strong class="cursor-pointer text-underline">click here to download.</strong>`);
    },
    downloadLink() {
      if (this.currentJob.apiJob === null) {
        return '#';
      }

      if (this.currentJob.apiJob.output.length === 1) {
        return this.currentJob.apiJob.output[0].download_uri;
      }

      if (this.currentJob.apiJob.output.length > 1) {
        
        if(this.currentJob.downloadedOutputs.length === 1){
          let download_uri = ""

          this.currentJob.apiJob.output.map((output)=>{
            if(output.id === this.currentJob.downloadedOutputs[0]){
              download_uri  = output.download_uri
            }
          }) 

          return download_uri
        }else{
          return this.currentJob.zipJob?.output[0].download_uri;
        }
      }

      return '#';
    },
  },
  filters: {
    decodeUrl(url) {
      try {
        return decodeURIComponent(url);
      } catch (e) {
        return url;
      }
    }
  },
};
</script>
<style lang="scss">
  .all-files-box {
    display: flex;
    padding: 5px;
    justify-content: center;
    align-items: flex-start;
    gap: 10px;
    border-radius: 5px;
    background: #2D5089;
    color: #D9E7FD;
  }

  .disabled {
    opacity: .5;
    cursor: not-allowed !important;
  }
</style>
